
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("eSo8y"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("eSo8y", function(module, exports) {

let $ad48d4f1beef3a12$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ad48d4f1beef3a12$var$load("h3ABO"),
    $ad48d4f1beef3a12$var$load("fSobj"),
    $ad48d4f1beef3a12$var$load("74u2y"),
    $ad48d4f1beef3a12$var$load("2YffH"),
    $ad48d4f1beef3a12$var$load("6mHrv"),
    $ad48d4f1beef3a12$var$load("awWN9"),
    $ad48d4f1beef3a12$var$load("9CYct"),
    $ad48d4f1beef3a12$var$load("bRKjd"),
    $ad48d4f1beef3a12$var$load("ap5Gz"),
    $ad48d4f1beef3a12$var$load("hZtKG"),
    $ad48d4f1beef3a12$var$load("iNmaF"),
    $ad48d4f1beef3a12$var$load("lVO3w"),
    $ad48d4f1beef3a12$var$load("hyzoX"),
    $ad48d4f1beef3a12$var$load("h9Ed7"),
    $ad48d4f1beef3a12$var$load("eBRUf"),
    $ad48d4f1beef3a12$var$load("b2zxR"),
    $ad48d4f1beef3a12$var$load("tKhaz"),
    $ad48d4f1beef3a12$var$load("GYf7c"),
    $ad48d4f1beef3a12$var$load("ceKWn"),
    $ad48d4f1beef3a12$var$load("cD6Zr"),
    $ad48d4f1beef3a12$var$load("dtASV"),
    $ad48d4f1beef3a12$var$load("9ZGcX"),
    $ad48d4f1beef3a12$var$load("9wzNh"),
    $ad48d4f1beef3a12$var$load("8YSo7"),
    $ad48d4f1beef3a12$var$load("3Zfzp"),
    $ad48d4f1beef3a12$var$load("Wowvf"),
    $ad48d4f1beef3a12$var$load("9ldRJ"),
    $ad48d4f1beef3a12$var$load("9anPW"),
    $ad48d4f1beef3a12$var$load("50ame"),
    $ad48d4f1beef3a12$var$load("3WB19"),
    $ad48d4f1beef3a12$var$load("1MlIV"),
    $ad48d4f1beef3a12$var$load("g9CVe"),
    $ad48d4f1beef3a12$var$load("7oiUM"),
    $ad48d4f1beef3a12$var$load("8t3po"),
    $ad48d4f1beef3a12$var$load("855o0"),
    $ad48d4f1beef3a12$var$load("8MfZE"),
    $ad48d4f1beef3a12$var$load("hv4mn"),
    $ad48d4f1beef3a12$var$load("dYtBN"),
    $ad48d4f1beef3a12$var$load("6wr18"),
    $ad48d4f1beef3a12$var$load("kjZZD"),
    $ad48d4f1beef3a12$var$load("2zxmz"),
    $ad48d4f1beef3a12$var$load("7269o"),
    $ad48d4f1beef3a12$var$load("jjLHK"),
    $ad48d4f1beef3a12$var$load("cxoS1"),
    $ad48d4f1beef3a12$var$load("37ldp"),
    $ad48d4f1beef3a12$var$load("ffEVr"),
    $ad48d4f1beef3a12$var$load("dRpV3"),
    $ad48d4f1beef3a12$var$load("dTsOE"),
    $ad48d4f1beef3a12$var$load("hhss7"),
    $ad48d4f1beef3a12$var$load("jwTn5"),
    $ad48d4f1beef3a12$var$load("aYdgM"),
    $ad48d4f1beef3a12$var$load("6u1hm"),
    $ad48d4f1beef3a12$var$load("klApM"),
    $ad48d4f1beef3a12$var$load("eQgf0"),
    $ad48d4f1beef3a12$var$load("8fMw3"),
    $ad48d4f1beef3a12$var$load("hogcU"),
    $ad48d4f1beef3a12$var$load("74vOE"),
    $ad48d4f1beef3a12$var$load("7EorR"),
    $ad48d4f1beef3a12$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.124175ef.js.map
